/* ============================================================
   OBF BUNDLE — engine v9d (Solstice upsell-cards-only)

   Layout: a "Buy more, save more" label + two upsell CARDS
   (2 pairs / 3 pairs). There is NO 1-pair row — the single pair is
   bought via the theme's native variant picker + buy button (which
   also drives the Google Merchant Center feed price). Nothing is
   auto-selected; the bundle CTA stays hidden until the shopper taps
   a card, which opens its per-pair gender/color/size pickers + the
   free-gift block (green = free only).

   Gift rules (driven by tier.insoleKey / tier.bagKey):
     1 pair  → insoleKey:null, bagKey:null  → no gifts
     2 pairs → insoleKey:"t1", bagKey:null   → CloudStep socks (color/size pick)
     3 pairs → insoleKey:"t1", bagKey:"t2"   → CloudStep socks + ShieldWash bag

   Changes vs v8:
   1. Two-column comparison CARDS instead of stacked rows; 1-pair is a
      small "just need one pair?" link, not a card.
   2. Gift color/size PICKER restored (resolveInsoleVariant honours the
      customer's giftSel; falls back to first-available).
   3. Selected card's pickers render full-width below both cards.
   ============================================================ */

(function () {
  'use strict';

  /* ─── Money ─────────────────────────────────────────────── */
  function money(cents, fmt) {
    var s = (cents / 100).toFixed(2);
    return fmt && fmt.indexOf('{{amount}}') !== -1 ? fmt.replace('{{amount}}', s) : '$' + s;
  }

  /* ─── Option helpers ────────────────────────────────────── */
  function optIdx(product, name) {
    if (!product || !product.options) return -1;
    var lc = (name || '').toLowerCase();
    for (var i = 0; i < product.options.length; i++)
      if ((product.options[i].name || '').toLowerCase() === lc) return i;
    return -1;
  }

  function optVals(product, name) {
    var i = optIdx(product, name);
    return i === -1 ? [] : (product.options[i].values || []);
  }

  function findVariant(product, color, size) {
    if (!product) return null;
    var ci = optIdx(product, 'Color'), si = optIdx(product, 'Size');
    for (var i = 0; i < product.variants.length; i++) {
      var v  = product.variants[i];
      var mc = ci === -1 || v['option'+(ci+1)] === color;
      var ms = si === -1 || v['option'+(si+1)] === size;
      if (mc && ms) return v;
    }
    return null;
  }

  function prodForGender(products, gender) { return products[gender] || null; }

  /* ─── Thumbnail ─────────────────────────────────────────── */
  function thumbFor(products, gender, color, size) {
    var p = gender ? prodForGender(products, gender) : (products.Women || products.Men);
    if (!p) return '';
    if (color) {
      var v = findVariant(p, color, size);
      if (v && v.image) return v.image;
      var ci = optIdx(p, 'Color');
      if (ci !== -1) {
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i]['option'+(ci+1)] === color && p.variants[i].image)
            return p.variants[i].image;
        }
      }
    }
    return p.image || '';
  }

  /* ─── Read the native variant picker (Solstice) ──────────────
     Solstice renders Colour as radio swatches (input[type=radio] inside
     fieldset.product-form__input--color) and Size as a <select> inside
     fieldset.product-form__input--dropdown. The hidden <input name="id"> is
     `disabled` and never updates, and the sticky bar has no SelectedVariant
     span — so the only reliable source is the SELECTED OPTION VALUES read
     straight off the controls (they reflect the shopper's click instantly,
     before any theme JS runs). data-handle = handleized option name
     ("Color"→"color", "Size"→"size"); the sticky controls use the same
     handles, so a scoped read keeps the two pickers from reading each other. */
  function pickerOptionValues(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var out = {};
    root.querySelectorAll('.product-form__input--dropdown').forEach(function(fs){
      var s = fs.querySelector('select');
      var h = fs.getAttribute('data-handle');
      if (s && h) out[h] = s.value;
    });
    root.querySelectorAll('.product-form__input--color, .product-form__input--block').forEach(function(fs){
      var r = fs.querySelector('input[type="radio"]:checked');
      var h = fs.getAttribute('data-handle');
      if (r && h) out[h] = r.value;
    });
    return out;
  }

  function genderOfCurrentProduct(config) {
    var pid = config.currentProductId;
    var keys = Object.keys(config.products);
    for (var i = 0; i < keys.length; i++) {
      if (config.products[keys[i]].id === pid) return keys[i];
    }
    return keys[0] || '';
  }

  function optHandle(name) { return String(name || '').replace(/ /g, '-').toLowerCase(); }

  /* Current native selection as {gender,color,size}. `scope` (optional)
     narrows the read to the <variant-selects> that changed. */
  function readThemeSel(config, scope) {
    var gender = genderOfCurrentProduct(config);
    var prod = gender ? config.products[gender] : (config.products.Women || config.products.Men);
    if (!prod) return { gender:'', color:'', size:'' };
    var vals = pickerOptionValues(scope);
    var ci = optIdx(prod, 'Color'), si = optIdx(prod, 'Size');
    var colorName = ci !== -1 ? prod.options[ci].name : 'Color';
    var sizeName  = si !== -1 ? prod.options[si].name : 'Size';
    return {
      gender: gender,
      color:  vals[optHandle(colorName)] || '',
      size:   vals[optHandle(sizeName)]  || ''
    };
  }

  /* ─── Push bundle pair #1 back into the native picker ─────────
     Keeps the page price/gallery in step with the bundle. Solstice may render
     EITHER picker_type: colour is always swatch radios, but Size can be a
     <select> (dropdown) OR radio buttons (button) depending on theme settings
     — this store uses "button", so set whichever control holds the value. */
  function setNativePickerValue(value) {
    if (!value) return;
    /* radios — colour swatches (--color) and button options (--block) */
    document.querySelectorAll('.product-form__input--color input[type="radio"], .product-form__input--block input[type="radio"]').forEach(function(r){
      if (r.value === value && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles:true })); }
    });
    /* selects — dropdown options (--dropdown) */
    document.querySelectorAll('.product-form__input--dropdown select').forEach(function(s){
      for (var i = 0; i < s.options.length; i++) {
        if (s.options[i].value === value) {
          if (s.value !== value) { s.value = value; s.dispatchEvent(new Event('change', { bubbles:true })); }
          break;
        }
      }
    });
  }
  function pushTheme(products, gender, color, size) {
    setNativePickerValue(color);
    setNativePickerValue(size);
  }

  /* ─── Cart drawer ───────────────────────────────────────── */
  function openDrawer() {
    var sels = ['cart-drawer','#cart-drawer','#CartDrawer','[data-cart-drawer]','.cart-drawer','.drawer--cart','.js-cart-drawer'];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el) {
        if (typeof el.open === 'function') { el.open(); return; }
        el.classList.add('active','open','is-open','is-active','cart-drawer--open');
        el.removeAttribute('hidden'); el.setAttribute('aria-hidden','false');
        return;
      }
    }
    ['cart:open','cart:toggle','drawer:open','openCartDrawer','cart-drawer:open'].forEach(function(n){
      document.dispatchEvent(new CustomEvent(n,{bubbles:true}));
      window.dispatchEvent(new CustomEvent(n,{bubbles:true}));
    });
    var btn = document.querySelector('[data-cart-toggle],[data-drawer-toggle="cart"],.cart-drawer__toggle,#CartToggle,[aria-controls="cart-drawer"]');
    if (btn) { btn.click(); return; }
    window.location.href = '/cart';
  }

  /* ─── Escape ─────────────────────────────────────────────── */
  function e(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  /* ─── Size label (display only) ──────────────────────────────
     The shoe size options carry a gender prefix/suffix (e.g. "W7",
     "M 9.5", "8 W"). The bundle already shows Gender next to Size, so the
     W/M is redundant — strip it for DISPLAY only. The real option value is
     never touched, so the correct Shopify variant is still added to cart. */
  function sizeLabel(s) {
    var out = String(s || '');
    out = out.replace(/^\s*[wmWM]\s*(?=[\d.])/, '');   /* leading W/M before a number: "W7" → "7" */
    out = out.replace(/([\d.])\s*[wmWM]\s*$/, '$1');   /* trailing W/M after a number: "9.5M" → "9.5" */
    out = out.trim();
    return out || String(s || '');
  }

  /* ─── Image color dropdown (shared by pair rows AND gift) ─────
     One custom button+menu where every colour option shows a thumbnail, so
     the shoe pairs and the CloudStep gift use the SAME control. `kindAttrs`
     carries the data-* the binder uses to route a click; `thumbFn(color)`
     returns the image url for a colour. */
  function colorDropdownHtml(kindAttrs, value, colors, thumbFn) {
    var caret = '<svg class="obf-color-dd-arrow" width="10" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="#1B3644" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var h = '<div class="obf-color-dd" ' + kindAttrs + '>';
    /* Button shows the SELECTED colour's product thumbnail + name (owner wants
       the product image visible in the colour control, not only in the open
       menu). When nothing is chosen yet a neutral placeholder keeps the label
       in a fixed spot. The label still ellipsises so long names don't break. */
    var curThumb = value ? thumbFn(value) : '';
    var btnThumb = curThumb
      ? '<img class="obf-color-dd-thumb" src="'+e(curThumb)+'" alt="" width="18" height="18" loading="lazy" decoding="async">'
      : '<span class="obf-color-dd-thumb obf-color-dd-thumb--empty" aria-hidden="true"></span>';
    h += '<button type="button" class="obf-color-dd-btn" aria-haspopup="listbox" aria-expanded="false">';
    h += btnThumb + '<span class="obf-color-dd-label">'+e(value || '—')+'</span>' + caret + '</button>';
    h += '<div class="obf-color-dd-menu" role="listbox" hidden>';
    colors.forEach(function(c) {
      var ct  = thumbFn(c);
      var img = ct ? '<img src="'+e(ct)+'" alt="" width="34" height="34" loading="lazy" decoding="async">' : '';
      h += '<button type="button" class="obf-color-dd-opt'+(value===c?' is-sel':'')+'" role="option" data-value="'+e(c)+'" aria-selected="'+(value===c?'true':'false')+'">'+img+'<span>'+e(c)+'</span></button>';
    });
    h += '</div></div>';
    return h;
  }

  /* Variant image for a colour on any single product (used for gift thumbs). */
  function productColorThumb(prod, color) {
    if (!prod) return '';
    var ci = optIdx(prod, 'Color');
    if (ci !== -1 && color) {
      for (var i = 0; i < prod.variants.length; i++) {
        if (prod.variants[i]['option'+(ci+1)] === color && prod.variants[i].image) return prod.variants[i].image;
      }
    }
    return prod.image || '';
  }

  /* ════════════════════════════════════════════════════════════
     WIDGET
  ════════════════════════════════════════════════════════════ */
  function OBFBundle(root) {
    var config;
    try { config = JSON.parse(root.getAttribute('data-obf-config')); }
    catch(err){ console.error('[OBF]',err); return; }

    var GP = config.giftProducts || {};

    /* OBF guard: pre-flight check — bail cleanly if any required hook
       is missing (e.g. a 3rd-party app like Beae/GemPages stripped the
       inner HTML of [data-obf-bundle]). Without this, every render() call
       below crashes on container.innerHTML / cta.disabled. */
    if (!root.querySelector('[data-obf-tiers]') || !root.querySelector('[data-obf-cta]')) {
      console.warn('[OBF] bundle hooks missing inside [data-obf-bundle]; skipping init');
      return;
    }

    var S = {
      tierId:  null,
      pairs:   [],
      giftSel: {},
      syncing: false
    };

    /* ── Tier helpers ─────────────────────────────────────── */
    function tier(id) {
      var tid = id !== undefined ? id : S.tierId;
      for (var i = 0; i < config.tiers.length; i++)
        if (config.tiers[i].id === tid) return config.tiers[i];
      return null;
    }
    function selTier()   { return tier(S.tierId); }
    function isSingle(t) { return t && t.quantity === 1; }

    function ensurePairs(qty) {
      while (S.pairs.length < qty) S.pairs.push({gender:'',color:'',size:''});
      S.pairs = S.pairs.slice(0, qty);
    }

    function basePrice() {
      var p = config.products.Women || config.products.Men;
      return p ? p.price : 0;
    }
    function pricePer(t)  { return basePrice() * (1 - t.discountPercent/100); }
    function totalC(t)    { return Math.round(pricePer(t) * t.quantity); }
    function regularC(t)  { return Math.round(basePrice() * t.quantity); }

    /* ── Gift helpers ─────────────────────────────────────── */
    function insoleProduct(t) { return t && t.insoleKey ? GP[t.insoleKey] || null : null; }
    function bagProduct(t)    { return t && t.bagKey    ? GP[t.bagKey]    || null : null; }

    function insoleHasVariants(t) {
      var gp = insoleProduct(t);
      return !!(gp && gp.variants && gp.variants.length > 1);
    }

    function firstAvailVariant(gp) {
      if (!gp || !gp.variants || !gp.variants.length) return null;
      for (var i = 0; i < gp.variants.length; i++) {
        if (gp.variants[i].available) return gp.variants[i];
      }
      return gp.variants[0];
    }

    /* OBF v9: gift variant follows the customer's picker (S.giftSel). If
       they have not picked (or partial), fall back to first available. */
    function resolveInsoleVariant(t) {
      var gp = insoleProduct(t);
      if (!gp || !gp.variants || !gp.variants.length) return null;
      var sel = (t && S.giftSel[t.id]) || {};
      if (sel.color || sel.size) {
        var ci = optIdx(gp, 'Color'), si = optIdx(gp, 'Size');
        for (var i = 0; i < gp.variants.length; i++) {
          var v  = gp.variants[i];
          var mc = ci === -1 || !sel.color || v['option'+(ci+1)] === sel.color;
          var ms = si === -1 || !sel.size  || v['option'+(si+1)] === sel.size;
          if (mc && ms && v.available) return v;
        }
      }
      return firstAvailVariant(gp);
    }

    /* ── Card gifts dedup guard ───────────────────────────── */
    function tierGifts(t) {
      var gp1 = insoleProduct(t);
      var gp2 = bagProduct(t);
      if (gp1 && gp2 && gp1.id === gp2.id) {
        console.warn('[OBF] obf_t1_gift_product and obf_t2_gift_product are the same product. Check metafields — obf_t2_gift_product should be ShieldWash Bag.');
        gp2 = null;
      }
      return { gp1: gp1, gp2: gp2 };
    }

    /* Highest-discount multi-pair tier = the "Best value" card (gets the
       green badge + warm tint), unless a tier is explicitly badgeStyle:best. */
    function bestTierId() {
      var best = null, bd = -1;
      config.tiers.forEach(function(t) {
        if (t.quantity >= 2 && t.discountPercent > bd) { bd = t.discountPercent; best = t.id; }
      });
      return best;
    }

    /* ── ONE comparison card (qty >= 2) ───────────────────── */
    function cardHtml(t) {
      var fmt  = config.moneyFormat;
      var sel  = t.id === S.tierId;
      var per  = pricePer(t);
      var g    = tierGifts(t);
      /* Badge look follows the owner's explicit "Badge style" setting per tier
         (Filled = "popular" colours, Outlined = "best" colours). It used to be
         auto-forced to "best" for the highest-discount tier, which made BOTH the
         Most Popular and Best Value badges render identically — owner now controls
         each badge's colours/size from theme settings. */
      var isBest = t.badgeStyle === 'best';

      var badge = t.badge
        ? '<div class="obf-card-badge '+(isBest?'is-best':'is-popular')+'">'+e(t.badge)+'</div>'
        : '';

      var nowStr = money(Math.round(per), fmt);
      var wasStr = t.discountPercent > 0 ? money(Math.round(basePrice()), fmt) : '';
      var saveAmt = regularC(t) - totalC(t);
      var saveStr = saveAmt > 0
        ? (config.labels.save || 'Save') + ' ' + money(saveAmt, fmt)
        : '';
      var discStr = t.discountPercent > 0 ? t.discountPercent + '% off' : '';

      var gifts = [];
      if (g.gp1) gifts.push(g.gp1.title);
      if (g.gp2) gifts.push(g.gp2.title);

      var h = '<div class="obf-card'+(sel?' is-selected':'')+(isBest?' is-best':'')+'" '
            + 'data-tier-id="'+t.id+'" role="button" tabindex="0" aria-pressed="'+(sel?'true':'false')+'">';
      h += badge;
      h += '<div class="obf-card-top">';
      h +=   '<div class="obf-card-check'+(sel?' is-on':'')+'"><span class="obf-card-check-dot"></span></div>';
      h +=   '<span class="obf-card-qty">'+e(t.label || (t.quantity + ' Pairs'))+'</span>';
      h += '</div>';

      h += '<div class="obf-card-price">';
      h +=   '<span class="obf-card-now">'+e(nowStr)+'</span>';
      h +=   '<span class="obf-card-per">'+e(config.labels.perPair || '/pair')+'</span>';
      if (wasStr) h += '<s class="obf-card-was">'+e(wasStr)+'</s>';
      h += '</div>';
      if (saveStr) h += '<div class="obf-card-save">'+e(saveStr)+(discStr ? ' · '+e(discStr) : '')+'</div>';

      /* Gifts on ONE compact green line (green = free, the only green).
         OBF r8: full gift names kept on the card per owner ("CloudStep Insoles free",
         or "CloudStep Insoles + ShieldWash Bag free" on the 3-pair tier). CSS keeps
         this on a single row on mobile (white-space:nowrap + small font). */
      if (gifts.length) {
        h += '<div class="obf-card-gifts"><span class="obf-card-gift">🎁 '+e(gifts.join(' + ') + ' free')+'</span></div>';
      }
      h += '</div>'; /* end card */
      return h;
    }

    /* ── Full-width body for the SELECTED tier ────────────── */
    function bodyHtml(t) {
      var single = isSingle(t);
      var g = tierGifts(t);

      var h = '<div class="obf-body-inner">';
      if (!single) {
        h += '<div class="obf-pair-rows-label">'
           + e((config.labels.chooseColors || 'Choose your colors')) + ' — '
           + '<strong>' + t.quantity + ' ' + e(config.labels.pair || 'Pair') + 's</strong>'
           + '</div>';
      }
      h += '<div class="obf-pair-rows">';
      S.pairs.forEach(function(pair, i) { h += pairRowHtml(pair, i, single); });
      h += '</div>';
      if (!single && (g.gp1 || g.gp2)) h += giftInlineHtml(t, g.gp1, g.gp2);
      h += '</div>';
      return h;
    }

    /* ── Render: "Buy more, save more" + 2/3-pair upsell cards ──
       The single pair is handled by the theme's native variant picker +
       buy button (which also drives the Google-feed price), so there is NO
       1-pair row here. */
    function renderTiers() {
      var container = root.querySelector('[data-obf-tiers]');

      var cardTiers = config.tiers.filter(function(t) { return t.quantity >= 2; });

      var html = '';

      /* "Buy more, save more" upsell label */
      if (cardTiers.length) {
        html += '<div class="obf-upsell-label"><span>'+e(config.labels.upsell || 'Buy more, save more')+'</span></div>';
      }

      /* Upsell comparison cards (2 / 3 pairs) */
      html += '<div class="obf-cards" data-cols="'+cardTiers.length+'">';
      html += cardTiers.map(cardHtml).join('');
      html += '</div>';

      /* Full-width pickers for the SELECTED card */
      var t = selTier();
      html += '<div class="obf-expand">';
      if (t && t.quantity >= 2) html += bodyHtml(t);
      html += '</div>';

      container.innerHTML = html;

      /* Whole upsell card toggles its tier */
      container.querySelectorAll('.obf-card').forEach(function(card) {
        card.addEventListener('click', function() { toggleTier(card.dataset.tierId); });
        card.addEventListener('keydown', function(ev) {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); toggleTier(card.dataset.tierId); }
        });
      });

      bindSelectEvents();
      bindColorDropdowns();
    }

    /* ── Pair row HTML ────────────────────────────────────── */
    function pairRowHtml(pair, i, single) {
      var prod        = pair.gender ? prodForGender(config.products, pair.gender) : null;
      var sizes       = prod ? optVals(prod, 'Size') : [];
      var colors      = (function() {
        var w = config.products.Women ? optVals(config.products.Women, 'Color') : [];
        var m = config.products.Men   ? optVals(config.products.Men,   'Color') : [];
        var r = w.slice();
        m.forEach(function(c) { if (r.indexOf(c) === -1) r.push(c); });
        return r;
      })();
      var genders      = Object.keys(config.products);
      var multiGender  = genders.length > 1;
      var sizeDisabled = !pair.gender || !pair.color;

      /* OBF v9f: no left "Pair N" column — the pair label sits on a slim line
         above the row so the gender/colour/size controls get the full width
         (colour names like "Aqua Blue" were getting clipped). */
      var html = '<div class="obf-pair-row" data-pi="'+i+'">';
      if (!single) {
        html += '<div class="obf-pair-label">'+(config.labels.pair||'Pair')+' '+(i+1)+'</div>';
      }

      /* Selects wrapper — grid with labels above each */
      html += '<div class="obf-pair-selects'+(multiGender?' has-gender':'')+'">';

      /* Gender */
      if (multiGender) {
        html += '<div class="obf-sel-group">';
        html += '<label class="obf-sel-label">'+e(config.labels.selectGender||'Gender')+'</label>';
        html += '<select class="obf-select obf-select--gender" data-pair="'+i+'" data-field="gender">';
        if (!pair.gender) html += '<option value="">—</option>';
        genders.forEach(function(g) {
          html += '<option value="'+e(g)+'"'+(pair.gender===g?' selected':'')+'>'+e(g)+'</option>';
        });
        html += '</select>';
        html += '</div>';
      }

      /* Color — shared image dropdown (thumbnail on every option) */
      html += '<div class="obf-sel-group">';
      html += '<label class="obf-sel-label">'+e(config.labels.selectColor||'Color')+'</label>';
      html += colorDropdownHtml('data-cc-kind="pair" data-cc-pair="'+i+'"', pair.color, colors, function(c){
        return thumbFor(config.products, pair.gender, c, '');
      });
      html += '</div>';

      /* Size */
      html += '<div class="obf-sel-group">';
      html += '<label class="obf-sel-label">'+e(config.labels.selectSize||'Size')+'</label>';
      html += '<select class="obf-select obf-select--size" data-pair="'+i+'" data-field="size"'+(sizeDisabled?' disabled':'')+' >';
      html += '<option value="">—</option>';
      /* Only show sizes that have an available variant for the chosen gender+color */
      var availSizes = sizes.filter(function(s) {
        if (!pair.color || !prod) return true; /* no filter until gender+color known */
        var v = findVariant(prod, pair.color, s);
        return v && v.available;
      });
      availSizes.forEach(function(s) {
        html += '<option value="'+e(s)+'"'+(pair.size===s?' selected':'')+'>'+e(sizeLabel(s))+'</option>';
      });
      html += '</select>';
      html += '</div>';

      html += '</div>'; /* end pair-selects */
      html += '</div>'; /* end pair-row */
      return html;
    }

    /* ── Free-gift block (gp1 = socks w/ picker, gp2 = bag) ── */
    function giftInlineHtml(t, gp1, gp2) {
      var gSel = S.giftSel[t.id] || {};

      /* Resolve display image for gp1 — switch to variant image when color is chosen */
      var gp1Img = gp1 ? gp1.image : null;
      if (gp1 && gSel.color) {
        var ci1 = optIdx(gp1, 'Color');
        for (var k = 0; k < gp1.variants.length; k++) {
          var vk = gp1.variants[k];
          if (ci1 !== -1 && vk['option'+(ci1+1)] === gSel.color && vk.image) {
            gp1Img = vk.image; break;
          }
        }
      }

      var giftCount = (gp1 ? 1 : 0) + (gp2 ? 1 : 0);
      var html = '<div class="obf-gift-inline">';
      /* OBF: "free" was said 3× (header + "included free" pill + per-item FREE
         badges). Keep only this one "Your free gift" header. */
      html += '<div class="obf-gift-inline-header">🎁 <strong>Your free gift'+(giftCount > 1 ? 's' : '')+'</strong></div>';

      /* ── Gift 1: CloudStep socks — with color/size picker ── */
      if (gp1) {
        var gColors = optVals(gp1, 'Color');
        var gSizes  = optVals(gp1, 'Size');
        var hasGColor = gColors.length > 0;
        var hasGSize  = gSizes.length  > 0;
        /* Only offer sizes that are available for the chosen color */
        var availGSizes = gSizes.filter(function(sz) {
          if (!hasGColor || !gSel.color) return true;
          var vv = findVariant(gp1, gSel.color, sz);
          return vv && vv.available;
        });

        html += '<div class="obf-gift-item">';
        html +=   '<div class="obf-gift-item-main">';
        if (gp1Img) {
          html += '<img class="obf-gift-item-img" src="'+e(gp1Img)+'" alt="'+e(gp1.title)+'" width="40" height="40" loading="lazy" decoding="async" data-gift-img="'+t.id+'">';
        }
        html +=     '<div class="obf-gift-item-info">';
        html +=       '<span class="obf-gift-item-name">'+e(gp1.title)+'</span>';
        html +=     '</div>';
        html +=   '</div>';

        if (hasGColor || hasGSize) {
          html += '<div class="obf-gift-pickers">';
          if (hasGColor) {
            /* Same image dropdown as the shoe pairs — each sock colour shows
               its product thumbnail (fixes "I don't see the product image"). */
            html += '<div class="obf-sel-group">';
            html += '<label class="obf-sel-label">'+e(config.labels.selectColor || 'Color')+'</label>';
            html += colorDropdownHtml('data-cc-kind="gift" data-cc-tid="'+t.id+'"', gSel.color, gColors, function(c){
              return productColorThumb(gp1, c);
            });
            html += '</div>';
          }
          if (hasGSize) {
            var gSizeDisabled = hasGColor && !gSel.color;
            html += '<div class="obf-sel-group">';
            html += '<label class="obf-sel-label">'+e(config.labels.selectSize || 'Size')+'</label>';
            html += '<select class="obf-select obf-select--gsize" data-tid="'+t.id+'" data-gfield="size"'+(gSizeDisabled?' disabled':'')+'>';
            html += '<option value="">—</option>';
            availGSizes.forEach(function(sz) {
              html += '<option value="'+e(sz)+'"'+(gSel.size===sz?' selected':'')+'>'+e(sz)+'</option>';
            });
            html += '</select></div>';
          }
          html += '</div>'; /* end gift-pickers */
        }
        html += '</div>'; /* end gift-item */
      }

      /* ── Gift 2: ShieldWash bag — fixed (no picker) ─────── */
      if (gp2) {
        html += '<div class="obf-gift-item obf-gift-item--divider">';
        html +=   '<div class="obf-gift-item-main">';
        if (gp2.image) {
          html += '<img class="obf-gift-item-img" src="'+e(gp2.image)+'" alt="'+e(gp2.title)+'" width="40" height="40" loading="lazy" decoding="async">';
        }
        html +=     '<div class="obf-gift-item-info">';
        html +=       '<span class="obf-gift-item-name">'+e(gp2.title)+'</span>';
        html +=     '</div>';
        html +=   '</div>';
        html += '</div>';
      }

      html += '</div>'; /* end gift-inline */
      return html;
    }

    /* ── renderPanel: kept for back-compat, delegates to renderTiers ── */
    function renderPanel() { renderTiers(); }

    /* ── Bind select events ───────────────────────────────── */
    function bindSelectEvents() {
      var container = root.querySelector('[data-obf-tiers]');

      /* Pair selects */
      container.querySelectorAll('.obf-select[data-pair]').forEach(function(sel) {
        sel.addEventListener('change', function(ev) {
          var i     = +ev.target.dataset.pair;
          var field = ev.target.dataset.field;

          S.pairs[i][field] = ev.target.value;
          if (field === 'gender') { S.pairs[i].color = ''; S.pairs[i].size = ''; }
          if (field === 'color') {
            /* Keep the existing size if it's still available for the new color.
               S.pairs[i].color is already the new color at this point. */
            var curSize = S.pairs[i].size;
            if (curSize) {
              var pChk = prodForGender(config.products, S.pairs[i].gender);
              var vChk = pChk ? findVariant(pChk, S.pairs[i].color, curSize) : null;
              if (!vChk || !vChk.available) S.pairs[i].size = '';
            }
          }

          /* Re-render to rebuild size options / swatch */
          if (field === 'gender' || field === 'color') {
            renderTiers();
          } else {
            renderCta();
          }

          /* Sync pair #1 back to theme */
          if (i === 0 && !S.syncing) {
            S.syncing = true;
            pushTheme(config.products, S.pairs[0].gender, S.pairs[0].color, S.pairs[0].size);
            S.syncing = false;
          }
        });
      });

      /* Gift selects */
      container.querySelectorAll('.obf-select[data-gfield]').forEach(function(sel) {
        sel.addEventListener('change', function(ev) {
          var tid   = ev.target.dataset.tid;
          var field = ev.target.dataset.gfield;
          if (!S.giftSel[tid]) S.giftSel[tid] = { color:'', size:'' };
          S.giftSel[tid][field] = ev.target.value;
          if (field === 'color') S.giftSel[tid].size = '';
          renderTiers();
          renderCta();
        });
      });
    }

    /* ── Apply a colour choice for a pair (mirrors the old <select> path) ── */
    function setPairColor(i, value) {
      S.pairs[i].color = value;
      /* Keep the existing size if it's still available for the new colour. */
      var curSize = S.pairs[i].size;
      if (curSize) {
        var pChk = prodForGender(config.products, S.pairs[i].gender);
        var vChk = pChk ? findVariant(pChk, value, curSize) : null;
        if (!vChk || !vChk.available) S.pairs[i].size = '';
      }
      renderTiers();
      /* Sync pair #1 back to the theme's native picker */
      if (i === 0 && !S.syncing) {
        S.syncing = true;
        pushTheme(config.products, S.pairs[0].gender, S.pairs[0].color, S.pairs[0].size);
        S.syncing = false;
      }
    }

    /* ── Apply a colour choice for a gift (CloudStep socks) ── */
    function setGiftColor(tid, value) {
      if (!S.giftSel[tid]) S.giftSel[tid] = { color:'', size:'' };
      S.giftSel[tid].color = value;
      S.giftSel[tid].size  = '';   /* sizes depend on colour availability */
      renderTiers();
      renderCta();
    }

    /* ── Close every open colour menu inside the widget ───── */
    function closeColorMenus(except) {
      root.querySelectorAll('.obf-color-dd.is-open').forEach(function(o) {
        if (o === except) return;
        o.classList.remove('is-open');
        var m = o.querySelector('.obf-color-dd-menu'); if (m) m.hidden = true;
        var b = o.querySelector('.obf-color-dd-btn');  if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    /* ── Bind the custom colour dropdowns ─────────────────── */
    function bindColorDropdowns() {
      var container = root.querySelector('[data-obf-tiers]');
      container.querySelectorAll('.obf-color-dd').forEach(function(dd) {
        var btn  = dd.querySelector('.obf-color-dd-btn');
        var menu = dd.querySelector('.obf-color-dd-menu');
        if (!btn || !menu) return;

        btn.addEventListener('click', function(ev) {
          ev.stopPropagation();
          var willOpen = !dd.classList.contains('is-open');
          closeColorMenus(dd);
          dd.classList.toggle('is-open', willOpen);
          menu.hidden = !willOpen;
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });

        var kind = dd.getAttribute('data-cc-kind');
        menu.querySelectorAll('.obf-color-dd-opt').forEach(function(opt) {
          opt.addEventListener('click', function(ev) {
            ev.stopPropagation();
            if (kind === 'gift') setGiftColor(dd.getAttribute('data-cc-tid'), opt.dataset.value);
            else                 setPairColor(+dd.getAttribute('data-cc-pair'), opt.dataset.value);
          });
        });
      });

      /* Outside-click / Esc closes any open colour menu (bound once). */
      if (!root.__obfColorDocBound) {
        root.__obfColorDocBound = true;
        document.addEventListener('click', function() { closeColorMenus(null); });
        document.addEventListener('keydown', function(ev) {
          if (ev.key === 'Escape') closeColorMenus(null);
        });
      }
    }

    /* ── Show / hide the theme's native buy buttons ─────────
       When a bundle tier is open we want only the bundle's own CTA on screen,
       so the native "Add to cart" (and the dynamic-checkout button + the
       mobile sticky bar) are hidden. When no tier is selected they come back —
       the single pair is still bought natively (and drives the Google feed). */
    function setNativeBuyVisible(visible) {
      var hide = !visible;
      document.querySelectorAll('button[name="add"]').forEach(function(btn) {
        if (root.contains(btn)) return; /* never touch our own CTA */
        /* When the native button is the live buy button (no bundle tier open),
           it should look like the bundle CTA — same deep-ocean fill + radius.
           The class is harmless while the button is hidden under a tier. */
        btn.classList.add('obf-native-styled');
        var wrap = btn.closest('.obf-block, .product-form__buttons, .product-form, product-form') || btn;
        wrap.classList.toggle('obf-native-hidden', hide);
      });
      document.querySelectorAll('.shopify-payment-button').forEach(function(el) {
        el.classList.toggle('obf-native-hidden', hide);
      });
      document.querySelectorAll('.product-add-to-cart-sticky, product-sticky, .product-sticky-atc').forEach(function(el) {
        el.classList.toggle('obf-native-hidden', hide);
      });
    }

    /* ── Render: CTA ──────────────────────────────────────── */
    function renderCta() {
      var t       = selTier();
      var cta     = root.querySelector('[data-obf-cta]');
      var priceEl = root.querySelector('[data-obf-cta-price]');
      var labelEl = root.querySelector('[data-obf-cta-label]');
      var fmt     = config.moneyFormat;

      /* OBF guard: cta is guaranteed by pre-flight, but priceEl/labelEl
         are optional inner hooks. Avoid 'Cannot read properties of null'. */
      if (!cta) return;

      /* A tier is open → suppress the theme's native buy button(s). */
      setNativeBuyVisible(!t);
      function setLabel(txt) { if (labelEl) labelEl.textContent = txt; }
      function setPrice(html) { if (priceEl) priceEl.innerHTML = html; }

      if (!t) {
        /* No bundle selected → the theme's native variant picker + buy button
           handle the single pair. Hide our CTA so there aren't two buttons. */
        cta.style.display = 'none';
        cta.dataset.mode  = 'passthrough';
        return;
      }
      cta.style.display = '';

      if (isSingle(t)) {
        cta.dataset.mode    = 'passthrough';
        setLabel(config.labels.addSingle || 'Add to Cart');
        setPrice(money(basePrice(), fmt));
        var p = S.pairs[0] || {};
        cta.disabled = !(p.gender && p.color && p.size);
        return;
      }

      cta.dataset.mode    = 'bundle';
      setLabel(config.labels.addToCart || 'Add to Cart');

      var tot = totalC(t), reg = regularC(t);
      setPrice(money(tot,fmt) + (reg > tot ? ' <s>'+money(reg,fmt)+'</s>' : ''));

      var pairsOk = S.pairs.length === t.quantity && S.pairs.every(function(p) {
        if (!p.gender || !p.color || !p.size) return false;
        var prod = prodForGender(config.products, p.gender);
        var v    = findVariant(prod, p.color, p.size);
        return !!(v && v.available);
      });
      var giftOk = !insoleHasVariants(t) || !!resolveInsoleVariant(t);

      cta.disabled = !(pairsOk && giftOk);
    }

    /* ── Toggle tier ──────────────────────────────────────── */
    function toggleTier(tierId) {
      if (S.tierId === tierId) {
        S.tierId = null; S.pairs = [];
      } else {
        S.tierId = tierId;
        var t = selTier();
        if (t) {
          ensurePairs(t.quantity);
          var th = readThemeSel(config);
          if (th.gender) {
            /* Pre-populate every EMPTY pair with the current theme selection.
               Already-customised pairs (gender !== '') are left untouched so
               switching between tier sizes keeps the customer's choices. */
            for (var pi = 0; pi < S.pairs.length; pi++) {
              if (!S.pairs[pi].gender) {
                S.pairs[pi] = { gender: th.gender, color: th.color, size: th.size };
              }
            }
          }
          /* Auto-select the first available insole color+size the first time
             this tier is opened (so the gift section is pre-filled). */
          if (!S.giftSel[tierId]) {
            var gp1auto = insoleProduct(t);
            if (gp1auto && gp1auto.variants && gp1auto.variants.length) {
              var ci1a = optIdx(gp1auto, 'Color');
              var si1a = optIdx(gp1auto, 'Size');
              var fv   = firstAvailVariant(gp1auto);
              S.giftSel[tierId] = {
                color: ci1a !== -1 ? fv['option'+(ci1a+1)] : '',
                size:  si1a !== -1 ? fv['option'+(si1a+1)] : ''
              };
            }
          }
        }
      }
      renderTiers(); renderCta();
    }

    /* ── Listen for theme changes ─────────────────────────── */
    function listenTheme() {
      /* `scope` = the <variant-selects> whose control changed (so the main
         picker and the sticky bar don't read each other). */
      function onThemeChange(scope) {
        if (S.syncing) return;
        /* Defer one tick so the radio/select reflects the click before we read
           (and so the theme's own handler has run). */
        setTimeout(function() {
          if (S.syncing) return;
          var t = selTier();
          if (!t || !S.pairs.length) return;
          var th = readThemeSel(config, scope);
          if (!th.gender) return;
          var cur = S.pairs[0] || {};
          if (cur.gender === th.gender && cur.color === th.color && cur.size === th.size) return; /* no real change */
          S.syncing = true;
          S.pairs[0] = { gender:th.gender, color:th.color, size:th.size };
          S.syncing = false;
          renderTiers(); renderCta();
        }, 0);
      }

      /* OBF v9f: read the SELECTED OPTION VALUES off Solstice's colour radios
         + size <select>. Every shopper change bubbles a native `change` from
         inside <variant-selects> (main picker AND the mobile sticky bar), so a
         single delegated capture listener catches them all. We scope the read
         to the picker that changed, and skip changes from our own bundle. */
      document.addEventListener('change', function (ev) {
        var tg = ev.target;
        if (!tg || !tg.closest) return;
        if (tg.closest('[data-obf-bundle]')) return;            /* ignore the bundle's own selects */
        var vs = tg.closest('variant-selects');
        if (vs || tg.closest('.product-form, .product-information, .product-add-to-cart-sticky')) {
          onThemeChange(vs || undefined);
        }
      }, true);

      /* Bonus: themes that broadcast a variant-change event (no DOM read needed). */
      ['variant:changed','variantChange','variant:change','on:variant:change'].forEach(function(n){
        document.addEventListener(n, function(){ onThemeChange(); });
      });
    }

    /* ── Validation helpers (color is now a custom dropdown) ── */
    function fieldEl(i, f) {
      if (f === 'color') return root.querySelector('.obf-color-dd[data-cc-kind="pair"][data-cc-pair="'+i+'"]');
      return root.querySelector('.obf-select[data-pair="'+i+'"][data-field="'+f+'"]');
    }
    function clearAllInvalid() {
      root.querySelectorAll('.obf-select.is-invalid, .obf-color-dd.is-invalid')
          .forEach(function(el){ el.classList.remove('is-invalid'); });
    }
    function firstInvalidEl() {
      return root.querySelector('.obf-select.is-invalid, .obf-color-dd.is-invalid');
    }

    /* ── Add to cart ──────────────────────────────────────── */
    function validate() {
      var cta  = root.querySelector('[data-obf-cta]');
      var mode = cta.dataset.mode;

      if (mode === 'passthrough') {
        /* Single-pair: validate and add via /cart/add.js so the user's
           chosen Women/Men variant is what hits the cart (the theme's
           native form is for the page product, which may be different
           from the gendered metafield products). */
        var t1 = selTier(); if (!t1) return;
        var p  = S.pairs[0] || {};
        clearAllInvalid();

        var okSingle = true;
        ['gender','color','size'].forEach(function(f){
          if (!p[f]) {
            okSingle = false;
            var el = fieldEl(0, f);
            if (el) el.classList.add('is-invalid');
          }
        });
        if (okSingle) {
          var prodS = prodForGender(config.products, p.gender);
          var vS    = findVariant(prodS, p.color, p.size);
          if (!vS || !vS.available) {
            okSingle = false;
            ['color','size'].forEach(function(f){
              var el = fieldEl(0, f);
              if (el) el.classList.add('is-invalid');
            });
          }
        }
        if (!okSingle) {
          var firstS = firstInvalidEl();
          if (firstS) firstS.scrollIntoView({ behavior:'smooth', block:'center' });
          return;
        }
        pushTheme(config.products, p.gender, p.color, p.size);
        doAdd(t1);
        return;
      }

      var t = selTier(); if (!t) return;
      clearAllInvalid();

      var ok = true;
      S.pairs.forEach(function(p,i){
        ['gender','color','size'].forEach(function(f){
          if (!p[f]) {
            ok = false;
            var el = fieldEl(i, f);
            if (el) el.classList.add('is-invalid');
          }
        });
        if (p.gender && p.color && p.size) {
          var prod = prodForGender(config.products, p.gender);
          var v    = findVariant(prod, p.color, p.size);
          if (!v || !v.available) {
            ok = false;
            ['color','size'].forEach(function(f){
              var el = fieldEl(i, f);
              if (el) el.classList.add('is-invalid');
            });
          }
        }
      });

      if (insoleHasVariants(t) && !resolveInsoleVariant(t)) {
        ok = false;
        root.querySelectorAll('.obf-select[data-gfield]').forEach(function(s){ s.classList.add('is-invalid'); });
      }

      if (!ok) {
        var first = firstInvalidEl();
        if (first) first.scrollIntoView({ behavior:'smooth', block:'center' });
        return;
      }
      doAdd(t);
    }

    function doAdd(t) {
      var cta = root.querySelector('[data-obf-cta]');
      cta.classList.add('is-loading'); cta.disabled = true;

      var bid     = 'OBF-'+t.quantity+'PK-'+Date.now();
      var per     = pricePer(t);
      var savings = ((basePrice()-per)/100).toFixed(2);

      /* Capture gift variant IDs now so the cart guard can re-add gifts
         later if the customer changes shoe quantity from the cart. */
      var iv  = resolveInsoleVariant(t);
      var gp2 = bagProduct(t);
      var giftInsoleId = iv ? String(iv.id) : '';
      var giftBagId    = (gp2 && gp2.variants && gp2.variants[0]) ? String(gp2.variants[0].id) : '';

      var items = S.pairs.map(function(p){
        var prod = prodForGender(config.products, p.gender);
        var v    = findVariant(prod, p.color, p.size);
        return { id:v.id, quantity:1, properties:{
          '_obf_bundle_id':bid, '_obf_bundle_size':t.quantity,
          '_obf_bundle_discount':t.discountPercent+'%',
          '_obf_savings_per_pair':savings,
          '_obf_gift_insole_id': giftInsoleId,
          '_obf_gift_bag_id':    giftBagId
        }};
      });

      /* CloudStep insoles */
      if (iv) items.push({ id:iv.id, quantity:1, properties:{ _obf_bundle_id:bid, _obf_gift:'insoles' } });

      /* ShieldWash bag — first variant, silent */
      if (gp2 && gp2.variants && gp2.variants[0])
        items.push({ id:gp2.variants[0].id, quantity:1, properties:{ _obf_bundle_id:bid, _obf_gift:'bag' } });

      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function(){
          cta.classList.remove('is-loading'); cta.disabled = false;
          ['cart:refresh','cart:updated','cart-drawer:refresh'].forEach(function(n){
            document.dispatchEvent(new CustomEvent(n,{bubbles:true}));
            window.dispatchEvent(new CustomEvent(n,{bubbles:true}));
          });
          openDrawer();
        })
        .catch(function(err){
          console.error('[OBF]',err);
          cta.classList.remove('is-loading'); cta.disabled = false;
          alert("Sorry — couldn't add to cart. Please try again.");
        });
    }

    /* ── Init ─────────────────────────────────────────────── */
    function init() {
      if (!config.tiers || !config.tiers.length) { root.style.display = 'none'; return; }
      if (!config.products.Women && !config.products.Men) {
        root.innerHTML = '<p style="padding:16px;color:#B23A2B">OBF Bundle: no products configured.</p>';
        return;
      }
      /* Bind CTA and theme listener before auto-selecting so events work immediately */
      root.querySelector('[data-obf-cta]').addEventListener('click', validate);
      listenTheme();
      /* OBF v9d: nothing auto-selected. The theme's native variant picker +
         buy button handle the single pair (and the Google-feed price). The
         bundle CTA stays hidden until the shopper opts into a 2/3-pair card. */
      renderTiers();
      renderCta();
    }

    init();
  }

  /* ── Boot ─────────────────────────────────────────────────── */
  function boot() {
    document.querySelectorAll('[data-obf-bundle]').forEach(function(el){
      if (!el.__obfInit) { el.__obfInit = true; OBFBundle(el); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
